/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteWebhook.defs.js";
export { main as default } from "./deleteWebhook.defs.js";
